import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import FarmerLogin from './pages/FarmerLogin';
import TruckLogin from './pages/TruckLogin';
import TruckPortal from './pages/TruckPortal';
import MELDashboard from './pages/MELDashboard';
import FarmerDashboard from './pages/FarmerDashboard';
import AdminDashboard from './pages/AdminDashboard';
import FieldAgentDashboard from './pages/FieldAgentDashboard';
import UserManagement from './pages/UserManagement';
import SpatialIntelligence from './pages/SpatialIntelligence';
import TraceabilityPage from './pages/Traceability';
// v1.5.2: new dedicated portals for finance + factory_clerk roles
import FinanceDashboard from './pages/FinanceDashboard';
import FactoryClerkDashboard from './pages/FactoryClerk';
// v1.6.3: warehouse portal (physical inventory management)
import WarehouseDashboard from './pages/WarehouseDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import PwaInstallPrompt from './components/PwaInstallPrompt';
// v2.7: National Command Center — top-level /command-center route (admin + finance)
import CommandCenter from './pages/CommandCenter'; // v2.7

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <PwaInstallPrompt />
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/farmer-login" element={<FarmerLogin />} />
              <Route path="/truck-login" element={<TruckLogin />} />
              {/* Public traceability page (QR code scan) */}
              <Route path="/t/:code" element={<TraceabilityPage />} />
              
              {/* Protected routes */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute roles={['admin', 'finance']}>
                    <MELDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute roles={['admin']}>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              {/* v1.5.2: dedicated Finance portal (was previously redirected to /dashboard) */}
              <Route
                path="/finance"
                element={
                  <ProtectedRoute roles={['finance', 'admin']}>
                    <FinanceDashboard />
                  </ProtectedRoute>
                }
              />
              {/* v1.5.2: dedicated Factory Clerk portal (was previously dead code) */}
              <Route
                path="/factory-clerk"
                element={
                  <ProtectedRoute roles={['factory_clerk', 'admin']}>
                    <FactoryClerkDashboard />
                  </ProtectedRoute>
                }
              />
              {/* v1.6.3: dedicated Warehouse portal (physical inventory + outbound) */}
              <Route
                path="/warehouse"
                element={
                  <ProtectedRoute roles={['factory_clerk', 'admin']}>
                    <WarehouseDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/field-agent"
                element={
                  <ProtectedRoute roles={['field_agent', 'admin']}>{/* v3.2: admin can now inspect/assist field agents */}
                    <FieldAgentDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/farmer-dashboard"
                element={
                  <ProtectedRoute roles={['farmer', 'admin']}>{/* v3.2: admin can now inspect/assist farmers */}
                    <FarmerDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/truck-portal"
                element={
                  <ProtectedRoute roles={['driver', 'admin']}>
                    <TruckPortal />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <ProtectedRoute roles={['admin']}>
                    <UserManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/spatial"
                element={
                  <ProtectedRoute roles={['admin', 'finance']}>
                    <SpatialIntelligence />
                  </ProtectedRoute>
                }
              />
              {/* v2.7: National Command Center — single-screen, all-of-Cameroon real-time dashboard */}
              <Route
                path="/command-center"
                element={
                  <ProtectedRoute roles={['admin', 'finance']}>
                    <CommandCenter />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
